var _defs, _g, _path, _rect, _rect2, _rect3, _path2, _ellipse, _g2, _g3, _g4, _path3, _g5, _g6, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndriodDeviceNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "510px",
    height: "1044px",
    viewBox: "0 0 510 1044",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3.2,0 C4.748,0 6,1.25182627 6,2.79961147 L6,64.3910639 C6,65.9388491 4.748,67.1906754 3.2,67.1906754 L0,67.1906754 L0,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3.2,0 C4.748,0 6,1.25342605 6,2.79961147 L6,129.182072 C6,130.728258 4.748,131.981684 3.2,131.981684 L0,131.981684 L0,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.5%",
    y: "-0.5%",
    width: "103.0%",
    height: "101.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.986922554   0 0 0 0 0.853477386   0 0 0 0 0.853477386  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 0,
    width: 463,
    height: 1001,
    rx: 43
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "50%",
    gradientTransform: "translate(0.5, 0.5), scale(0.8705, 1), rotate(90), scale(1, 1.2081), translate(-0.5, -0.5)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E8FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FAFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "0%",
    fx: "50%",
    fy: "0%",
    r: "99.8989292%",
    gradientTransform: "translate(0.5, 0), scale(0.7526, 1), rotate(90), scale(1, 0.9625), translate(-0.5, -0)",
    id: "radialGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFE8FD",
    stopOpacity: 0.0768411276,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "0%",
    fx: "50%",
    fy: "0%",
    r: "99.8989292%",
    gradientTransform: "translate(0.5, 0), scale(0.6814, 1), rotate(90), scale(1, 1.0631), translate(-0.5, -0)",
    id: "radialGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEAFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFE8FD",
    stopOpacity: 0.0768411276,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Devices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0, -0.0006)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 0.2734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B8A7A5",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 504.704,
    height: 1043.72715,
    rx: 64.8316
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#DFD7D7",
    strokeWidth: 3.82972,
    x: 1.91484,
    y: 1.9145743,
    width: 500.872,
    height: 1039.89568,
    rx: 62.9168
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,8.09623644 L440.4,8.09623644 C471.62,8.09623644 496.928,33.4004847 496.928,64.6150328 L496.928,980.887874 C496.928,1012.10355 471.62,1037.40803 440.4,1037.40803 L64,1037.40803 C32.78128,1037.40803 7.47356,1012.10355 7.47356,980.887874 L7.47356,64.6150328 C7.47356,33.4004847 32.78132,8.09623644 64,8.09623644 Z",
    id: "Path",
    stroke: "#D1C4C1",
    strokeWidth: 0.547104,
    fill: "#EDE4E0",
    fillRule: "nonzero"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#736A68",
    fillRule: "nonzero",
    x: 8.75392,
    y: 9.57287154,
    width: 486.648,
    height: 1026.49354,
    rx: 54.7104
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D3C6C4",
    strokeWidth: 0.547104,
    x: 9.02744,
    y: 9.84639354,
    width: 486.1,
    height: 1025.94962,
    rx: 54.4368
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#020501",
    fillRule: "nonzero",
    x: 13.95116,
    y: 14.4960282,
    width: 477.072,
    height: 1017.4708,
    rx: 49.5128
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.6,9.82247684 L337.6,9.82247684 L337.6,10.6223658 C337.6,11.2849938 337.0628,11.8221993 336.4,11.8221993 L168.8,11.8221993 C168.1372,11.8221993 167.6,11.2849938 167.6,10.6223658 L167.6,9.82247684 Z",
    id: "Path",
    fill: "#2C2C2C",
    fillRule: "nonzero"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 250.0256,
    cy: 41.3006683,
    rx: 1.641308,
    ry: 1.64108025
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped",
    transform: "translate(504, 453.3611)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.09, 0)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C1B0AC",
    points: "0.09 0 0.91 0 0.91 67.2546665 0.09 67.2546665"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B0A19F",
    points: "0.91 0 2.006 0 2.006 67.2546665 0.91 67.2546665"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C0B6B6",
    points: "2.006 0 3.918 0 3.918 67.2546665 2.006 67.2546665"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9F4EC",
    points: "3.918 0 5.014 0 5.014 67.2546665 3.918 67.2546665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.014,0 L5.014,0 C5.618,0 6.11,0.487932285 6.11,1.09584792 L6.11,66.1588186 C6.11,66.7627348 5.618,67.2546665 5.014,67.2546665 L5.014,67.2546665 L5.014,0 Z",
    fill: "#F8ECE6"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped",
    transform: "translate(504, 264.5873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.09, 0)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C1B0AC",
    points: "0.09 0 0.91 0 0.91 132.105667 0.09 132.105667"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B0A19F",
    points: "0.91 0 2.006 0 2.006 132.105667 0.91 132.105667"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C0B6B6",
    points: "2.006 0 3.918 0 3.918 132.105667 2.006 132.105667"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9F4EC",
    points: "3.918 0 5.014 0 5.014 132.105667 3.918 132.105667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.014,0 L5.014,0 C5.618,0 6.11,0.489532063 6.11,1.0938482 L6.11,131.012618 C6.11,131.617734 5.618,132.105667 5.014,132.105667 L5.014,132.105667 L5.014,0 Z",
    fill: "#F8ECE6"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.42,
    fill: "#121A18",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    },
    x: 334.5532,
    y: 0,
    width: 7.933,
    height: 9.57295148
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.42,
    fill: "#121A18",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    },
    x: 4,
    y: 244.766032,
    width: 10,
    height: 7.99888993
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.42,
    fill: "#121A18",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    },
    x: 4,
    y: 914.273118,
    width: 10,
    height: 7.99888993
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.42,
    fill: "#121A18",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    },
    x: 4.6504,
    y: 76.8569339,
    width: 9.30076,
    height: 7.93189922
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.42,
    fill: "#121A18",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    },
    x: 70.8496,
    y: 1036.06822,
    width: 9.30076,
    height: 7.93189922
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.42,
    fill: "#121A18",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    },
    x: 428.656,
    y: 1036.06822,
    width: 9.30076,
    height: 7.93189922
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "overview-value-props-spatial-spiral",
    filter: "url(#filter-5)",
    transform: "translate(23, 19.0006)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1FAFF",
    xlinkHref: "#path-6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.816969,811.204853 L83.6192179,852.05402 C63.9389646,861.133225 46.3495372,850.070288 44.3321322,826.716545 C44.2097894,825.289141 44.147483,823.842167 44.1454485,822.382038 L44,718.475214 C43.968426,695.252683 52.1711004,675.979779 66.5008341,666.850688 C118.399139,646.946685 150.51442,657.072999 162.846676,680.036846 C174.842227,700.166961 192.393616,736.778091 215.500842,779.564824 C221.23581,787.718634 210.013032,799.86309 190.434064,808.465471 C188.272518,809.475283 186.057594,810.394105 183.816969,811.204853 Z",
    id: "Path-14",
    fillOpacity: 0.549060315,
    fill: "#E4EEFF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(191, 212.0006) scale(-1, -1) rotate(90) translate(-191, -212.0006)translate(-2, 44.0006)",
    fill: "url(#radialGradient-8)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386,336 C335.955619,331.719745 285.911239,327.370454 238.246148,310.456544 C190.581056,293.542634 145.295254,263.995069 125.785083,226.508321 C106.274913,189.021574 112.540374,143.664681 95.8060407,104.590097 C79.1510171,65.584549 39.5755085,32.7922745 0,9.92576231e-14 L343,9.92576231e-14 C366.748244,9.48951414e-14 386,19.2517558 386,43 L386,336 L386,336 Z",
    id: "Path",
    filter: "url(#filter-9)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(75, 33.0006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(164, 1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 0.2735512,
    fill: "#000000",
    cx: 11.89948,
    cy: 11.8978288,
    rx: 11.89948,
    ry: 11.8978288
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 9.41148,
    cy: 9.5537541,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85708,13.8123631 C11.65348,15.5629202 11.16988,15.498929 10.94188,15.1797733 C10.80508,15.4533354 10.64108,15.672105 10.53188,16.0004594 C10.39508,16.4108025 10.94188,16.8207456 11.35228,16.9575266 C11.76268,17.0943076 13.67748,16.4108025 14.08788,16.1372404 C14.49828,15.8636784 15.59228,15.0429923 15.72908,14.4958682 C15.86588,13.9491441 16.00268,11.3507047 16.00268,11.0771427 C16.00268,10.8035806 16.13948,10.5300186 16.00268,10.1196756 C15.89348,9.7917211 15.31868,9.8917072 15.04548,9.9828945 C14.95428,10.2108629 14.71708,10.7487882 14.49828,11.0771427 C14.22468,11.4874857 14.36148,11.6242668 12.85708,13.8123631 Z",
    id: "Path",
    fill: "#494067"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#8F85AC",
    transform: "translate(14.1167, 14.2991) rotate(22.5431) translate(-14.1167, -14.2991)",
    cx: 14.1166653,
    cy: 14.2990926,
    rx: 1,
    ry: 1.27442114
  })), /*#__PURE__*/React.createElement("g", {
    id: "ANdroid_status",
    transform: "translate(252, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4167356,5.9755 L5.59806897,1.1875 L4.55926437,1.1875 L4.55926437,7.4539375 L1.1977931,4.2595625 L0.0143448276,5.4541875 L4.28312644,9.5676875 L0,13.68 L1.1954023,14.874625 L4.55448276,11.68025 L4.55448276,17.8125 L5.72836782,17.8125 L10.411954,13.159875 L6.67990805,9.5676875 L10.4167356,5.9755 Z M6.23282759,4.0933125 L8.10841379,5.9553125 L6.23282759,7.7579375 L6.23282759,4.0933125 Z M8.10841379,13.18125 L6.23282759,15.04325 L6.23282759,11.37625 L8.10841379,13.18125 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2221885,16.9132062 C31.8499402,16.9132062 31.4778115,16.7430375 31.240046,16.4025812 L30.7822069,15.7470812 C30.2322023,14.95965 30.7995402,13.8827062 31.7643494,13.8827062 L32.6800276,13.8827062 C33.6448368,13.8827062 34.2121747,14.95965 33.6621701,15.7470812 L33.204331,16.4025812 C32.9665655,16.7430375 32.5944368,16.9132062 32.2221885,16.9132062 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1998161,11.5307437 C34.8585287,11.0428356 34.398777,10.6483956 33.8632368,10.3839394 C33.3276966,10.1194831 32.7337011,9.9935725 32.1361195,10.0178687 C31.5601747,9.97840812 30.984469,10.0990462 30.4736736,10.3662575 C29.9629977,10.6334569 29.5371954,11.0366844 29.2442023,11.5307437",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1980046,8.25913375 C36.5942529,6.62172563 34.412046,5.6682225 32.1132874,5.60032125 C30.9978575,5.62234938 29.8986851,5.86939688 28.8822345,6.32645375 C27.8659034,6.7835225 26.9534529,7.441065 26.2008276,8.25913375",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2413793,4.9875 C38.7334253,2.70978 35.5077517,1.36677688 32.1144828,1.1875 C28.8074023,1.32791 25.6704276,2.68190938 23.3103448,4.9875",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(50.8046, 0)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24321839,4.71405437 L0.724891954,4.58185 L0.980588506,2.05957625 L3.59672644,2.05957625 L3.59672644,2.65447812 L1.53047356,2.65447812 L1.37638621,4.03216812 C1.46974713,3.97882562 1.58761379,3.92895062 1.73010575,3.88256687 C1.87486897,3.83618312 2.04055172,3.81299125 2.2273931,3.81299125 C2.46312644,3.81299125 2.67447356,3.85358 2.86131494,3.9347575 C3.04803678,4.0136075 3.20678621,4.12726312 3.33756322,4.27570062 C3.47061149,4.42413812 3.57222069,4.60272625 3.64227126,4.811465 C3.71232184,5.02020375 3.74734713,5.25329812 3.74734713,5.51073625 C3.74734713,5.75426875 3.7133977,5.97808875 3.64573793,6.18218437 C3.58034943,6.38629187 3.48113103,6.56488 3.34808276,6.71796062 C3.21503448,6.86871375 3.04684138,6.98583687 2.84374253,7.06933 C2.64291494,7.152835 2.40598621,7.19457562 2.13283678,7.19457562 C1.92734713,7.19457562 1.73237701,7.1667525 1.54792644,7.1110825 C1.36586667,7.05309687 1.20245517,6.96612437 1.05769195,6.85015312 C0.9152,6.73187812 0.798528736,6.58575625 0.70743908,6.41179937 C0.61874023,6.23553875 0.562675862,6.02911562 0.539365517,5.79254187 L1.15571494,5.79254187 C1.18368736,5.98273187 1.23975172,6.14275937 1.32378851,6.27264812 C1.40782529,6.402525 1.51756322,6.50109937 1.6530023,6.56835937 C1.79071264,6.63330375 1.95065747,6.66577 2.13283678,6.66577 C2.28692414,6.66577 2.42343908,6.63909875 2.54262069,6.58575625 C2.66168276,6.53241375 2.76197701,6.4558675 2.84374253,6.35614125 C2.92550805,6.25640312 2.98731034,6.13580062 3.02938851,5.99432187 C3.07373793,5.85284312 3.09585287,5.6939675 3.09585287,5.517695 C3.09585287,5.3576675 3.07373793,5.20923 3.02938851,5.0723825 C2.98503908,4.93554687 2.91845517,4.81609625 2.82975632,4.71405437 C2.74332874,4.61200062 2.63717701,4.53313875 2.51106207,4.47748062 C2.38494713,4.419495 2.24018391,4.39050812 2.07677241,4.39050812 C1.85968736,4.39050812 1.69508046,4.419495 1.58295172,4.47748062 C1.47321379,4.53546625 1.3600092,4.61431625 1.24321839,4.71405437 Z M8.39471264,4.60272625 L8.39471264,6.45703125 C8.3315954,6.54979875 8.23118161,6.65418 8.09347126,6.77013937 C7.95576092,6.883795 7.76545287,6.98352125 7.52266667,7.06933 C7.28215172,7.152835 6.97158621,7.19457562 6.59108966,7.19457562 C6.28052414,7.19457562 5.99446437,7.14123312 5.73302989,7.03454812 C5.47386667,6.92553562 5.24853333,6.76782375 5.05714943,6.56140062 C4.86803678,6.35266187 4.72088276,6.099855 4.6158069,5.80298 C4.51312184,5.50378937 4.46171954,5.16516187 4.46171954,4.78710937 L4.46171954,4.3939875 C4.46171954,4.015935 4.50606897,3.67847125 4.59488736,3.38159625 C4.68585747,3.08472125 4.81890575,2.83306625 4.99403218,2.62664312 C5.16915862,2.41790437 5.38397241,2.2601925 5.63847356,2.1535075 C5.89297471,2.044495 6.18477241,1.98998875 6.51398621,1.98998875 C6.90392644,1.98998875 7.22967356,2.05724875 7.49110805,2.19176875 C7.75493333,2.32397312 7.96042299,2.50720437 8.10745747,2.74145062 C8.25688276,2.97570875 8.35263448,3.24243312 8.39471264,3.54162375 L7.71871264,3.54162375 C7.68834943,3.3583925 7.62774253,3.19140625 7.53665287,3.04065312 C7.44795402,2.88988812 7.32064368,2.76928562 7.15496092,2.67883375 C6.98915862,2.58605437 6.77554023,2.53967062 6.51398621,2.53967062 C6.27825287,2.53967062 6.07395862,2.582575 5.90110345,2.66839562 C5.72836782,2.75421625 5.5859954,2.87713437 5.47386667,3.03717375 C5.36185747,3.19720125 5.27770115,3.39087062 5.22175632,3.61817 C5.16796322,3.8454575 5.14118621,4.10174375 5.14118621,4.38702875 L5.14118621,4.78710937 C5.14118621,5.07934125 5.17501609,5.34027062 5.24267586,5.56988562 C5.31272644,5.79950062 5.41194483,5.99548562 5.54045057,6.15784062 C5.66883678,6.31786812 5.82172874,6.43963437 5.99924598,6.5231275 C6.17891494,6.6066325 6.37747126,6.64837312 6.59455632,6.64837312 C6.83507126,6.64837312 7.03004138,6.62866062 7.17946667,6.58923562 C7.32889195,6.54748312 7.44556322,6.49878375 7.5296,6.44311375 C7.61363678,6.38512812 7.67794943,6.33062187 7.72229885,6.27960687 L7.72229885,5.14544937 L6.54207816,5.14544937 L6.54207816,4.60272625 L8.39471264,4.60272625 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7241379,0 C20.199669,0 20.6558345,0.187666562 20.9921011,0.52171625 C21.3283678,0.85576475 21.5172414,1.30883875 21.5172414,1.78125 L21.5172414,19 L17.9310345,19 L17.9310345,1.78125 C17.9310345,1.30883875 18.119908,0.85576475 18.4561747,0.52171625 C18.7924414,0.187666562 19.2486069,0 19.7241379,0 L19.7241379,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7471264,4.75 C14.2226575,4.75 14.678823,4.9376725 15.0150897,5.27171625 C15.3513563,5.60576 15.5402299,6.05883875 15.5402299,6.53125 L15.5402299,19 L11.954023,19 L11.954023,6.53125 C11.954023,6.05883875 12.1428966,5.60576 12.4791632,5.27171625 C12.8154299,4.9376725 13.2715954,4.75 13.7471264,4.75 L13.7471264,4.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77011494,9.5 C8.24564598,9.5 8.70181149,9.6876725 9.03807816,10.0217162 C9.37434483,10.35576 9.56321839,10.8088387 9.56321839,11.28125 L9.56321839,19 L5.97701149,19 L5.97701149,11.28125 C5.97701149,10.8088387 6.16588506,10.35576 6.50215172,10.0217162 C6.83841839,9.6876725 7.29458391,9.5 7.77011494,9.5 L7.77011494,9.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79310345,14.25 C2.26863448,14.25 2.7248,14.437625 3.06106667,14.7716688 C3.39733333,15.1057125 3.5862069,15.5588625 3.5862069,16.03125 L3.5862069,19 L0,19 L0,16.03125 C0,15.5588625 0.188873563,15.1057125 0.52514023,14.7716688 C0.861406897,14.437625 1.31757241,14.25 1.79310345,14.25 L1.79310345,14.25 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.0689655,16.03125 C84.9592736,16.03125 83.8951264,15.5934187 83.1104644,14.8139437 C82.3259218,14.0344687 81.8850575,12.9773562 81.8850575,11.875 L81.8850575,7.125 C81.8850575,6.02269125 82.3259218,4.96553125 83.1104644,4.18609187 C83.8951264,3.40664062 84.9592736,2.96875 86.0689655,2.96875 L98.0229885,2.96875 C99.1326805,2.96875 100.196828,3.40664062 100.98149,4.18609187 C101.766032,4.96553125 102.206897,6.02269125 102.206897,7.125 L102.804598,7.125 C103.121618,7.125 103.425729,7.250115 103.649986,7.47280687 C103.874124,7.69551062 104,7.99755125 104,8.3125 L104,10.6875 C104,11.0024487 103.874124,11.3044894 103.649986,11.5271931 C103.425729,11.749885 103.121618,11.875 102.804598,11.875 L102.206897,11.875 C102.206897,12.9773562 101.766032,14.0344687 100.98149,14.8139437 C100.196828,15.5934187 99.1326805,16.03125 98.0229885,16.03125 L86.0689655,16.03125 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    x: 83.6781609,
    y: 4.75,
    width: 16.7356322,
    height: 9.5,
    rx: 2.4
  })), /*#__PURE__*/React.createElement("text", {
    id: "09:20",
    fill: "#0D0C0C",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 20,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "09:20")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.049061,858.975999 C321.445768,894.188089 296.304151,943.023905 241.648463,977.607208 C186.719497,1012.19051 102.276459,1032.5213 59.0984658,1008.62738 C15.9204723,984.733464 14.0075232,916.614837 39.968975,871.132554 C65.9304268,825.859866 119.766279,803.433119 175.241803,803.013927 C230.990604,802.38514 288.925633,823.973504 305.049061,858.975999 Z",
    id: "Path",
    fill: "url(#radialGradient-10)",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M474.138143,703.582601 C492.248791,738.794691 464.479131,787.630506 404.110305,822.213809 C343.439635,856.797112 250.169799,877.127902 202.478426,853.233984 C154.787054,829.340066 152.674145,761.221439 181.349337,715.739156 C210.02453,670.466468 269.487823,648.03972 330.762182,647.620529 C392.338384,646.991741 456.32934,668.580106 474.138143,703.582601 Z",
    id: "Path",
    fill: "url(#radialGradient-11)",
    fillRule: "nonzero",
    transform: "translate(321.1066, 755.6072) rotate(45) translate(-321.1066, -755.6072)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndriodDeviceNew);
export default __webpack_public_path__ + "static/media/AndriodDeviceNew.4dd5c6f511e266847385343576f381a9.svg";
export { ForwardRef as ReactComponent };